<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { NameFormModal } from '@/components/document/sub-components/file-manager/sub-components/name-form-modal';

// Owns only the new-folder strings and emit name; the form behaviour lives in NameFormModal, shared
// with RenameModal and CopyModal (see that component for why the three were merged).
//
// No initialValue: this one starts empty, which is also why NameFormModal's unconditional select() on
// open is harmless here — selecting an empty input does nothing.

const { t } = useI18n();

const emit = defineEmits<{
  (e: 'close'): void;
  (e: 'create', name: string): void;
}>();
</script>

<template>
  <NameFormModal
    :title="t('fileManager.fileExplorerView.fileExplorerHandler.newFolderModal.title')"
    :label="t('fileManager.fileExplorerView.fileExplorerHandler.newFolderModal.nameLabel')"
    :placeholder="t('fileManager.fileExplorerView.fileExplorerHandler.newFolderModal.namePlaceholder')"
    :submit-label="t('fileManager.fileExplorerView.fileExplorerHandler.newFolderModal.createButton')"
    :cancel-label="t('fileManager.fileExplorerView.fileExplorerHandler.newFolderModal.cancel')"
    :close-aria-label="t('fileManager.fileExplorerView.fileExplorerHandler.newFolderModal.closeAriaLabel')"
    @submit="(name: string) => emit('create', name)"
    @close="emit('close')"
  />
</template>
